import { Referral } from '../types';
import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';
import React from 'react';
import { Button } from 'react-bootstrap';
import { openUrlInNewTab } from '../../util/window-utils';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import clsx from 'clsx';
import { useCurrentUser } from '../../user/hooks/useCurrentUser';
import { composeExternalUrl } from '../utils';

const REFERRAL_LOGO_HEIGHT = '36px';

export const ReferralTile = (props: { referral: Referral }) => {
  const { referral } = props;
  const user = useCurrentUser();

  const url = referral.url ? composeExternalUrl(referral.url, user) : undefined;
  return (
    <div className="referral-tile__container">
      <div className="referral-tile__header-container">
        <div className="referral-tile__header-new-container">
          {!!referral.new && (
            <div
              className={clsx('referral-tile__new-label-container', {
                'referral-tile__new-label-container--hidden': !referral.new,
              })}
            >
              <span className="growegy-font12--weight700 growegy-font-em">New</span>
            </div>
          )}
        </div>
        <img
          alt={referral.name}
          height={REFERRAL_LOGO_HEIGHT}
          src={referral.logo}
          className="referral-tile__logo"
        />
      </div>
      {referral.showName && <div className="growegy-font16--weight700">{referral.name}</div>}
      <div className="referral-tile__separator" />
      <div className="">
        <Markdown className="referral-tile__pitch markdown-container" remarkPlugins={[remarkGfm]}>
          {referral.pitch}
        </Markdown>
      </div>
      <div className="referral-tile__description-container">
        <Markdown className="referral-tile__description" remarkPlugins={[remarkGfm]}>
          {referral.descriptionMarkdown}
        </Markdown>
        {referral.featureImage && (
          <img
            alt={`${referral.name} feature`}
            src={referral.featureImage}
            className="referral-tile__feature-image"
          />
        )}
      </div>
      {url && (
        <Button
          type="button"
          className="referral-tile__visit-button"
          onClick={() =>
            openUrlInNewTab(url, {
              analyticsEvent: AnalyticsEvent.MARKETPLACE_LINK_OPENED,
              properties: { referralCode: referral.code },
            })
          }
          data-test="referral-tile__visit-button"
        >
          {referral.buttonText ?? 'Visit'}
        </Button>
      )}
    </div>
  );
};
